module.exports = __webpack_public_path__ + "static/media/under16-birth-kit-graphic.49f2bfa7.png";